import React, { Component, useEffect, useState } from "react";
import ComponentMutationMobile from "./ComponentMutationMobile";
import ComponentMutationWeb from "./ComponentMutationWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentMutation = () => {
  const gaEventTracker = useAnalyticsEventTracker("Mutation");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Mutation",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentMutationWeb></ComponentMutationWeb>
      </BrowserView>
      <MobileView>
        <ComponentMutationMobile></ComponentMutationMobile>
      </MobileView>
    </>
  );
};

export default ComponentMutation;
